module.exports = __webpack_public_path__ + "img/permata.868ef1f2.svg";